import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Col, Row } from 'react-bootstrap';
import { ILeadData, IPremiumCalculationStateGM } from 'Services/widgets/interfaces';
import { LoadingSpinner } from 'App/components/utils/LoadingSpinner';
import { IProductDataGM } from '../GarantieMax';
import cloneDeep from 'lodash/cloneDeep';
import { DeviceTypes } from 'Services/widgets/enums';

import CheckIconUrl from 'assets/bf-images/check_icon_gm.svg';

export interface IViewTariffResultProps {
  tariffData: IPremiumCalculationStateGM | null;
  lead: ILeadData;
  productData: IProductDataGM;
}

export const ViewTariffResult: React.FC<IViewTariffResultProps> = ( { tariffData, lead, productData } ) => {
  const { t } = useTranslation( [ 'widgets', 'base' ] );

  if ( tariffData === null ) {
    return <LoadingSpinner />;
  }

  const { premiumData, error } = tariffData;
  if ( error !== null ) {
    return <p>{ error }</p>;
  }

  const getCountFamily = (): number => {
    let resCount = 0;
    const deviceItems = lead.subStep1DeviceItems!;
    const devices = deviceItems.filter( ( device ) => device.typeDevice === DeviceTypes.MobileDevice );
    const devicesCount = devices.length;

    if ( devicesCount === 2 ) {
      resCount = 1;
    }

    if ( devicesCount === 3 ) {
      resCount = 2;
    }

    if ( devicesCount === 4 ) {
      resCount = 3;
    }

    return resCount;
  };

  const countFamily = getCountFamily();

  const getProtectionCount = (): number => {
    let countProtect = 0;
    const savedData = cloneDeep( lead.subStep1TariffData! );
    const devices = lead.subStep1DeviceItems!;

    devices.forEach( ( device ) => {
      const extendedCoverage = savedData[`extendedCoverage_${device.insuredId}`];

      if ( extendedCoverage && extendedCoverage === '1' )
      {
        countProtect = countProtect+1;
      }

    } );

    return countProtect;
  };

  const protectionCount = getProtectionCount();

  const formatPrice = ( price: number ): string => {
    if ( price ) {
      return ( price / 100 ).toFixed( 2 ).replace( '.', ',' );
    }

    return '';
  };

  return (
    <Fragment>
      { premiumData !== null && (
        <Card id="view-tariff" className="sticky-top z-idx-auto">
          <Card.Body>
            { premiumData.invoiceItems.sort( ( a, b ) => ( a.premiumFormulaId < b.premiumFormulaId ) ? -1 : 1 )
              .map( ( item, idx ) => (
                <Row key={ idx } className="bf-tarif-info">
                  <Col sm={ 12 } className="text-center mt-3">
                    { premiumData.creditAmount > 0 ? (
                      <p className="mb-0 white-space-nowrap">
                        <span className="gm-dicount">{ formatPrice( premiumData.grossAmount ) } € </span>
                        <span className="gm-old-price">
                          { formatPrice( item.grossAmount ) } €
                        </span> / { t( 'bookingFunnel.timeOptions.year' ) }
                      </p>
                    ) : (
                      <p className="mb-0 white-space-nowrap">
                        { formatPrice( item.grossAmount ) } € / { t( 'bookingFunnel.timeOptions.year' ) }
                      </p>
                    ) }
                  </Col>
                  <Col sm={ 12 } className="mt-4">
                    <p className="mb-0 white-space-nowrap f-16">
                      <img className="mr-2 mb-2" src={ CheckIconUrl } alt="Chaeck" />
                      <span className="font-weight-600">{ t( 'bookingFunnel.totatlDevices' ) } </span>
                          (1x 99 € / { t( 'bookingFunnel.timeOptions.year' ) })
                    </p>
                    { countFamily > 0 && (
                      <p className="mb-0 white-space-nowrap f-16">
                        <img className="mr-2 mb-2" src={ CheckIconUrl } alt="Chaeck" />
                        <span className="font-weight-600">
                          { `${ countFamily }x ${ t( 'bookingFunnel.familyTitle' ) } ` }
                        </span>
                          ({ countFamily }x 59 € / { t( 'bookingFunnel.timeOptions.year' ) })
                      </p>
                    ) }

                    { protectionCount > 0 && (
                      <p className="mb-0 white-space-nowrap f-16">
                        <img className="mr-2 mb-2" src={ CheckIconUrl } alt="Chaeck" />
                        <span className="font-weight-600">
                          { `${ protectionCount }x ${ t( 'bookingFunnel.additionalProtection' ) } ` }
                        </span>
                          ({ protectionCount }x 79 € / { t( 'bookingFunnel.timeOptions.year' ) })
                      </p>
                    ) }
                  </Col>
                </Row>
              ) ) }
          </Card.Body>
        </Card>
      ) }
    </Fragment>
  );
};
